import { Component } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

import ContactInfo, { IContactInfoProps } from './ContactInfo';

interface IContactsSectionProps {
  contacts: Array<IContactInfoProps>;
  title?: string;
}

class ContactsSection extends Component<IContactsSectionProps> {
  public override render() {
    const { contacts, title } = this.props;
    return (
      <Col>
        <Text as="h4" className="text-subheader-lg">
          {title ? title : 'Your Contacts'}
        </Text>
        {contacts.map(({ email, name, onClick, organization, phone }, index) => (
          <ContactInfo
            email={email}
            key={index}
            name={name}
            onClick={onClick}
            organization={organization}
            phone={phone}
          />
        ))}
      </Col>
    );
  }
}

export default ContactsSection;
